import { render, staticRenderFns } from "./DesktopPaginationBar.vue?vue&type=template&id=f5e3602a"
import script from "./DesktopPaginationBar.vue?vue&type=script&lang=js"
export * from "./DesktopPaginationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports